// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { TooltipProvider } from "react-tooltip";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
// import Main from "./pages/Main";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import InstancePage from "./pages/InstancePage";
// import ChatbotWithSettings from "./pages/ChatbotWithSettings";
// import ChatbotsList from "./pages/ChatbotList";
// import Docs from "./pages/Docs";
import BlankLayout from "./components/layouts/BlankLayout";
import Layout from "./components/layouts/Layout";
import { useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import ForgetPassword from "./pages/ForgetPassword";
import Forbidden403 from "./pages/Forbidden403";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import WhatsappBusiness from "./pages/WhatsappBusiness";
import WhatsappPhoneDetail from "./pages/WhatsappPhoneDetail";
import Templates from "./pages/Templates";
import TemplateCreator from "./pages/TemplateCreator";
import Campaigns from "./pages/Campaigns";
import RetargetCampaign from "./pages/RetargetCampaign";
import CampaignAnalytics from "./pages/CampaignAnalytics";
import FlowBuilder from "./pages/FlowBuilder";
import FlowList from "./pages/FlowList";
import WhatsAppFlows from "./pages/WhatsAppFlows";
import LiveChats from "./pages/LiveChats";
import ContactsHub from "./pages/contacts/ContactsHub";
import DownloadCenter from "./pages/DownloadCenter";
import Agents from "./pages/Agents";
import ChatStatuses from "./pages/ChatStatuses";
import AgentAnalysis from "./pages/AgentAnalysis";
import Invoices from "./pages/Invoices";
import ApiKeys from "./pages/ApiKeys";
import ApiDocs from "./pages/ApiDocs";
import { LiveChatProvider } from "./contexts/LiveChatContext";
import SubscriptionGate from "./components/SubscriptionGate";
import SectionRoute from "./components/SectionRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";

function App() {
  useEffect(() => {
    if (window.location.pathname === "/") {
      window.location.replace("/login");
    }
  }, []);

  return (
    <TooltipProvider>
    <Router>
      <Routes>
        {/* Wrap login with BlankLayout */}
        <Route
          path="/login"
          element={
            <BlankLayout>
              <Login />
            </BlankLayout>
          }
        />

        <Route
          path="/forget-password"
          element={
            <BlankLayout>
              <ForgetPassword />
            </BlankLayout>
          }
        />

        <Route
          path="/signup"
          element={
            <BlankLayout>
              <Signup />
            </BlankLayout>
          }
        />

        <Route
          path="/403"
          element={
            <BlankLayout>
              <Forbidden403 />
            </BlankLayout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />

        <Route
          path="/waba"
          element={
            <Layout>
              <SectionRoute section="phone_numbers">
                <WhatsappBusiness />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/waba/:phoneId"
          element={
            <Layout>
              <SectionRoute section="phone_numbers">
                <WhatsappPhoneDetail />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/templates"
          element={
            <Layout>
              <SectionRoute section="templates">
                <Templates />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/templates/create"
          element={
            <Layout>
              <SectionRoute section="templates">
                <TemplateCreator />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/broadcast"
          element={
            <Layout>
              <SectionRoute section={["broadcasting", "campaigns"]}>
                <SubscriptionGate>
                  <Campaigns />
                </SubscriptionGate>
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/campaigns"
          element={
            <Layout>
              <SectionRoute section={["broadcasting", "campaigns"]}>
                <Campaigns />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/campaigns/:campaignId/retarget"
          element={
            <Layout>
              <SectionRoute section={["broadcasting", "campaigns"]}>
                <SubscriptionGate>
                  <RetargetCampaign />
                </SubscriptionGate>
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/campaigns/:campaignId/analytics"
          element={
            <Layout>
              <SectionRoute section={["broadcasting", "campaigns"]}>
                <CampaignAnalytics />
              </SectionRoute>
            </Layout>
          }
        />
        
        <Route
          path="/flow-builder"
          element={
            <Layout>
              <SectionRoute section="flows">
                <FlowBuilder />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/flows/builder/:flowId"
          element={
            <Layout>
              <SectionRoute section="flows">
                <SubscriptionGate>
                  <FlowBuilder />
                </SubscriptionGate>
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/flows/builder"
          element={
            <Layout>
              <SectionRoute section="flows">
                <FlowBuilder />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/flow-list"
          element={
            <Layout>
              <SectionRoute section="flows">
                <SubscriptionGate>
                  <FlowList />
                </SubscriptionGate>
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/flows"
          element={
            <Layout>
              <SectionRoute section="flows">
                <FlowList />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/whatsapp-flows"
          element={
            <Layout>
              <SectionRoute section="flows">
                <WhatsAppFlows />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/profile"
          element={
            <Layout>
              <SectionRoute section="profile">
                <Profile />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/invoices"
          element={
            <Layout>
              <Invoices />
            </Layout>
          }
        />

        <Route
          path="/settings"
          element={
            <Layout>
              <SectionRoute section="settings">
                <Settings />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/live-chats"
          element={
            <Layout>
              <SectionRoute section={["livechats", "livechats.own", "livechats.all"]}>
                <SubscriptionGate>
                  <LiveChats />
                </SubscriptionGate>
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/contacts"
          element={
            <Layout>
              <SectionRoute section="contacts_management">
                <ContactsHub />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/contact-lists"
          element={<Navigate to="/contacts?tab=lists" replace />}
        />

        <Route
          path="/download-center"
          element={
            <Layout>
              <SectionRoute section="downloads">
                <DownloadCenter />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/agents"
          element={
            <Layout>
              <SectionRoute section="agents">
                <Agents />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/chat-statuses"
          element={
            <Layout>
              <SectionRoute section="agents">
                <ChatStatuses />
              </SectionRoute>
            </Layout>
          }
        />
        <Route
          path="/agent-analysis"
          element={
            <Layout>
              <SectionRoute section="agents">
                <AgentAnalysis />
              </SectionRoute>
            </Layout>
          }
        />

        <Route
          path="/api-keys"
          element={
            <Layout>
              <SuperAdminRoute>
                <ApiKeys />
              </SuperAdminRoute>
            </Layout>
          }
        />

        <Route
          path="/api-docs"
          element={
            <Layout>
              <ApiDocs />
            </Layout>
          }
        />
      </Routes>

      {/* Add ToastContainer here - this is what was missing! */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 9999 }}
      />
    </Router>
    </TooltipProvider>
  );
}

export default App;
